import React from 'react';

const TileHeader = ({ title, icon: Icon }) => {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center justify-between p-4 sm:p-6 border-b border-gray-100 gap-4">
      <div className="flex items-center gap-3">
        {Icon && (
          <div className="w-10 h-10 rounded-xl bg-tenant-light flex items-center justify-center text-tenant-dark">
            <Icon size={20} strokeWidth={2} />
          </div>
        )}
        <h2 className="text-[17px] font-bold text-gray-900">{title}</h2>
      </div>
    </div>
  );
};

export default TileHeader;
